import React from 'react'
import _ from 'lodash'
import { Col } from 'react-styled-flexboxgrid'
import { calculatePrice, DailyUsage } from '@aitodotai/aito-price-tool'
import { PoseGroup } from 'react-pose'
import * as styles from './styles'
import * as calculatorStyles from '../PricingCalculator/styles'


export default class PricingFormCalculator extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      queries: 1000,
      data: 1,
    }

    this.onFormChange = this.onFormChange.bind(this)
  }

  onFormChange(event) {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  render() {
    const { queries, data } = this.state
    const du = new DailyUsage(data, 0)
    const simulatedUsage = _.map(_.range(30 - 1), i => i).map(() => du)
    simulatedUsage.push(new DailyUsage(data, queries))
    const totalPrice = calculatePrice(simulatedUsage)

    return (
      <styles.Container>
        <styles.Header>Estimate your costs</styles.Header>
        <styles.InputRowContainer>
          <styles.LabelCol sm={3} xs={4}>
            <styles.InputLabel>Queries:</styles.InputLabel>
          </styles.LabelCol>
          <Col sm={6} xs={9}>
            <styles.PriceInput value={queries} name="queries" onChange={this.onFormChange} />
          </Col>
        </styles.InputRowContainer>
        <styles.InputRowContainer>
          <styles.LabelCol sm={3} xs={4}>
            <styles.InputLabel>Data:</styles.InputLabel>
          </styles.LabelCol>
          <Col sm={6} xs={9}>
            <styles.PriceInput value={data} name="data" onChange={this.onFormChange} />
          </Col>
          <Col xs={1}>
            <styles.InputLabel>GB</styles.InputLabel>
          </Col>
        </styles.InputRowContainer>
        <styles.InputRowContainer>
          <styles.LabelCol xs={12}>
            <styles.CostLabel>Estimated cost:</styles.CostLabel>
          </styles.LabelCol>
          <Col sm={7} xs={12}>
            <calculatorStyles.Price>
              <calculatorStyles.PriceSlot>
                <PoseGroup>
                  {
                    <calculatorStyles.PriceNumber key="price">
                      {totalPrice.toFixed(2)}
                      {' '}

                      <calculatorStyles.PricePerPeriod>
                        &euro; /
                        {' '}
                        30 days
                      </calculatorStyles.PricePerPeriod>
                    </calculatorStyles.PriceNumber>
                  }
                </PoseGroup>
              </calculatorStyles.PriceSlot>

              <calculatorStyles.PriceExplanation>
                {}
                <br />
                {}
              </calculatorStyles.PriceExplanation>
            </calculatorStyles.Price>
          </Col>
        </styles.InputRowContainer>
      </styles.Container>
    )
  }
}
